import { css } from '@emotion/react';
import { gray5, white, danger } from 'styles/global_defaults/colors';
import { quarterSpacing } from 'styles/global_defaults/scaffolding';
import { textMediumFontSize } from 'styles/global_defaults/fonts';
import { darkGray } from 'athena/styles/colors';
import t from 'react-translate';

import NvGooglePlacesAutocomplete from 'components/nv-google-places-autocomplete';

const styles = css`
  .input-label {
    color: ${darkGray};
    font-size: ${textMediumFontSize}px;
  }
  &.required {
    .input-label::after {
      content: '*';
      color: ${danger};
    }
  }
  .location-input {
    border-color: ${gray5};
    background-color: ${white};
    border-radius: ${quarterSpacing}px;
  }
`;

type LocationQuestionProps = {
  title: string;
  answer: string;
  isRequired?: boolean;
  dataQa?: string;
  dataQaId?: string;
  onChange: (value: any) => void;
};

const LocationQuestion = ({
  title,
  answer,
  isRequired,
  dataQa,
  dataQaId,
  onChange,
}: LocationQuestionProps) => (
  <div
    css={styles}
    className={isRequired ? 'required' : ''}
    data-qa={dataQa}
    data-qa-id={dataQaId}
  >
    <div className='input-label text-regular semi-bold mb-1'>
      {title}
    </div>
    <NvGooglePlacesAutocomplete
      value={answer}
      className='location-input'
      onChange={onChange}
      placeholder={t.PROFILE.LOCATION_PLACEHOLDER()}
    />
  </div>
);

export default LocationQuestion;
